import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { openModalBottom } from './ui';

export const startLoadingTransacciones = (suscripcionId) => {
  return async (dispatch) => {
    try {
      const resp = await fetchConToken(`suscripciones/transacciones/${suscripcionId}`);
      const body = await resp.json();

      if (body.ok) {
        dispatch(setTransacciones(body.transacciones || []));
      } else {
        dispatch(openModalBottom({ text: ['Error cargando transacciones'], timeOut: 4 }));
      }
    } catch (error) {
      console.error('Error cargando transacciones:', error);
      dispatch(openModalBottom({ text: ['Error en el servidor'], timeOut: 4 }));
    }
  };
};

export const setTransacciones = (transacciones) => ({
  type: types.transaccionesLoad,
  payload: transacciones
});
